import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCtaImageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCtaImageQuery = { __typename?: 'Query', wf_trialModeLeads_designImage?: { __typename?: 'WF_TrialModeLeads_DesignImageConnection', edges?: Array<{ __typename?: 'WF_TrialModeLeads_DesignImageEdge', node: { __typename?: 'WF_TrialModeLeads_DesignImage', id: string, imageFileName?: string | null, imageType?: string | null, imageFileURL?: string | null } }> | null } | null };


export const GetCtaImageDocument = gql`
    query GetCTAImage {
  wf_trialModeLeads_designImage(filter: {imageType: {eq: "encourage-character"}}) {
    edges {
      node {
        id
        imageFileName
        imageFileURL: imageFileName @wf_blobSignature(name: "TRIAL_MODE_DESIGNED_CHARACTERS_SIGNATURE")
        imageType
      }
    }
  }
}
    `;

/**
 * __useGetCtaImageQuery__
 *
 * To run a query within a React component, call `useGetCtaImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCtaImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCtaImageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCtaImageQuery(baseOptions?: Apollo.QueryHookOptions<GetCtaImageQuery, GetCtaImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCtaImageQuery, GetCtaImageQueryVariables>(GetCtaImageDocument, options);
      }
export function useGetCtaImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCtaImageQuery, GetCtaImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCtaImageQuery, GetCtaImageQueryVariables>(GetCtaImageDocument, options);
        }
export type GetCtaImageQueryHookResult = ReturnType<typeof useGetCtaImageQuery>;
export type GetCtaImageLazyQueryHookResult = ReturnType<typeof useGetCtaImageLazyQuery>;
export type GetCtaImageQueryResult = Apollo.QueryResult<GetCtaImageQuery, GetCtaImageQueryVariables>;